import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'substring',
    standalone: false
})
export class SubstringPipe implements PipeTransform {
  public transform(value: string, length: number): string {
    return value.substring(0, length);
  }
}
